/**
 * Returns the text of an HTML string or fragment, with entities decoded and
 * leading and trailing whitespace kept. Scripts in it are never run.
 */
export function stripHtml(html: string): string {
  // A template parses its content as a fragment and holds it inert. Fragment
  // parsing keeps leading whitespace and scripts in place. Parsing a whole
  // document drops whitespace before the first element and moves a leading
  // script into `<head>`.
  const template = document.createElement('template');
  template.innerHTML = html;
  return template.content.textContent ?? '';
}
